import axios from "axios";

const SignInFormHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .post(`${process.env.REACT_APP_NODE_URL}/login`, data, {
        withCredentials: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        console.error(error);
      });
  });
};

const EmailverificationHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_NODE_URL}/forgot-password/verify-email`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        console.error(error);
      });
  });
};

const ForgotPwdOtpHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_NODE_URL}/forgot-password/verify-otp`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const ForgotPwdOtpResendHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/forgot-password/resend-otp`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

const ForgotPwdHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .put(
        `${process.env.REACT_APP_NODE_URL}/forgot-password/update-password`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => console.log(err));
  });
};

export {
  SignInFormHooks,
  EmailverificationHooks,
  ForgotPwdOtpHooks,
  ForgotPwdOtpResendHooks,
  ForgotPwdHooks,
};
